import React, { useState } from "react";

import { Navbar, Nav, Container } from "react-bootstrap";
import { BsMenuUp, BsMenuDown } from "react-icons/bs";

const AppNavbar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNavOpen = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <div className="pb-1">
      <Navbar
        variant="dark"
        expand="lg"
        fixed="top"
        className="gradient-bg-welcome"
      >
        <Container>
          <Navbar.Brand href="#home" as="h1" className="text-accent">
            Portfolio App
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="nav-item">
            <span onClick={toggleNavOpen}>
              {isNavOpen ? <BsMenuUp size={26} /> : <BsMenuDown size={25} />}
            </span>
          </Navbar.Toggle>
          <Navbar.Collapse id="nav-items" className="justify-content-end">
            <Nav>
              <Nav.Link href="#home">Home</Nav.Link>
              <Nav.Link href="#about">About Me</Nav.Link>
              <Nav.Link href="#skills">Skills</Nav.Link>
              <Nav.Link href="#projects">My Projects</Nav.Link>
              <Nav.Link href="#contact">Contact Me</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default AppNavbar;
